/* eslint-disable prefer-destructuring */
export const INTEGRATION_SERVICE_ROOT = import.meta.env.VITE_INTEGRATION_SERVICE_ROOT;
export const MLAPI_ROOT = import.meta.env.VITE_ML_API_ROOT;
export const MARKET_ANALYSIS_API_ROOT = import.meta.env.VITE_MARKET_ANALYSIS_API_ROOT;
export const TINYMCE_API_KEY = import.meta.env.VITE_TINYMCE_API_KEY;
export const GF_VERSION = import.meta.env.VITE_GF_VERSION;
export const DEV = import.meta.env.DEV;
export const AWS_CLOUDFRONT_DOMAIN = import.meta.env.AWS_CLOUDFRONT_DOMAIN;
